import { render, staticRenderFns } from "./myContractDetails.vue?vue&type=template&id=0197a055&scoped=true"
import script from "./myContractDetails.vue?vue&type=script&lang=js"
export * from "./myContractDetails.vue?vue&type=script&lang=js"
import style0 from "./myContractDetails.vue?vue&type=style&index=0&id=0197a055&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197a055",
  null
  
)

export default component.exports